import React, { Component } from "react";

class LaborCrewDetails extends Component {
  render() {
    const {
      laborCrew,
      projLaborList,
      handleClick_editLaborCrewDetails,
      handleClick_deleteLaborCrew,
    } = this.props;
    return (
      <React.Fragment>
        {laborCrew ? (
          <React.Fragment>
            <h3 className="card-title mx-0">{laborCrew.crewName}</h3>
          </React.Fragment>
        ) : (
          <h5 className="text-muted">No crew selected</h5>
        )}
        {laborCrew && (
          <React.Fragment>
            <hr className="my-2" />
            <dl className="row mx-0">
              <dt className="col-sm-4 pl-4">Crew Size:</dt>
              <dd className="col-sm-8">{laborCrew.crewCount || "(N/A)"}</dd>
              <dt className="col-sm-4 pl-4">Created By:</dt>
              <dd className="col-sm-8">{laborCrew.createdByUserFullName || "(N/A)"}</dd>
              <dt className="col-sm-4 pl-4">Created On:</dt>
              <dd className="col-sm-8">{laborCrew.createdOn || "(N/A)"}</dd>
              <dt className="col-sm-4 pl-4">Members:</dt>
              <dd className="col-sm-8">
                <ul className="list-group list-group-flush border-top border-bottom">
                  {laborCrew.laborIds &&
                    laborCrew.laborIds.length > 0 &&
                    projLaborList &&
                    laborCrew.laborIds.map((labId) => {
                      const labor = projLaborList.find((l) => l.laborId === labId);
                      if (labor !== undefined)
                        return (
                          <li
                            key={`laborCrewDetailsLaborKey_${labId}`}
                            className="list-group-item pl-1 py-1"
                          >
                            {labor.fullName}
                          </li>
                        );
                      return (
                        <li
                          key={`laborCrewDetailsLaborKey_error`}
                          className="list-group-item pl-1 py-1"
                        >
                          ERROR!
                        </li>
                      );
                    })}
                </ul>
              </dd>
            </dl>
            <button
              type="button"
              name="editLaborCrewDetails"
              id="editLaborCrewDetails"
              className="btn btn-secondary m-2"
              onClick={handleClick_editLaborCrewDetails}
            >
              Edit Details...
            </button>
            <button
              type="button"
              name="deleteLaborCrew"
              id="deleteLaborCrew"
              className="btn btn-danger"
              onClick={handleClick_deleteLaborCrew}
            >
              Delete
            </button>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default LaborCrewDetails;
